<!-- 导航 -->
<template>
  <header id="header">
    <div class="warp">
      <a href="/#/"><img src="@/assets/logo2.png"></a>
      <div class="right">
        <span>累计捐赠<i>{{ statistics.currency }}</i>元</span>
        <span>捐赠实物<i>{{ statistics.material.toFixed(0) }}</i>件</span>
      </div>
    </div>
  </header>
</template>

<script>
import { donateStatistics } from '@/api'

export default {
  name: 'heade',
  data () {
    return {
      statistics: {
        currency: 0,
        material: 0
      }
    }
  },
  methods: {
    getStatistics () {
      donateStatistics().then(response => {
        if (response && response.data && response.data.success === true) {
          // console.log(response.data)
          var s = response.data.data
          s.forEach(item => {
            // console.log(item)
            this.statistics.material = this.statistics.material + item.material
            this.statistics.currency = this.statistics.currency + item.currency
          })
        } else if (response && response.data && response.data.success === false) {
        }
      })
    }
  },
  created () {
    this.getStatistics()
  }
}
</script>

<style lang="less">
  #header{
    background: #1f1f1f;
    .warp {
      height: 99px;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img{
        height: 64px;
        width: 283px;
      }
      .right {
        color: #fff;
        font-size: 18px;
        span{
          margin-left: 46px;
          i{
            color: #ff7800;
            font-style: normal;
            margin-left: 14px;
            margin-right: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Heade.vue